import React, { ReactElement } from 'react'
import { StyleSheet, View, StyleProp, TextStyle, ViewStyle, ViewProps } from 'react-native'

import { Color, Spacing } from '../../style'

import MenuItem from './item'

import { MenuItemProps } from '.'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  divider: {
    backgroundColor: Color.calmGrey,
    height: 1,
    marginVertical: Spacing.XS,
  },
})

export interface MenuItemData extends Omit<MenuItemProps, 'unfolded' | 'hasItems' | 'indentation'> {
  key: string
  divider?: boolean
  items?: MenuItemData[]
  hasItems?: boolean
  unfoldAtTop?: boolean
  contentContainerStyle?: StyleProp<ViewStyle>
}

export interface Props extends ViewProps {
  data: MenuItemData[]
  unfolded?: boolean
  textStyle?: StyleProp<TextStyle>
  iconStyle?: StyleProp<ViewStyle>
}
const Menu = (props: Props) => {
  const { data, unfolded, style, iconStyle, textStyle, ...otherProps } = props

  const renderItem = (item: MenuItemData, level = 0): ReactElement => {
    const {
      key,
      divider,
      items,
      hasItems,
      unfoldAtTop,
      active,
      style,
      iconStyle: itemIconStyle,
      textStyle: itemTextStyle,
      contentContainerStyle,
      ...otherProps
    } = item

    const itemIsOpened = (item: MenuItemData): boolean => {
      return item.selected || item.active || item.opened || !!item.items?.find(itemIsOpened)
    }

    const opened = itemIsOpened(item)
    return (
      <View key={key} style={style}>
        <View style={contentContainerStyle}>
          {divider && <View style={styles.divider} />}
          {unfoldAtTop && !unfolded && opened && items?.map((item) => renderItem(item, level + 1))}
          <MenuItem
            unfolded={unfolded}
            indentation={level}
            hasItems={hasItems !== undefined ? hasItems : !!items?.length}
            testID="Menu.Item"
            active={active !== false ? active || opened : false}
            iconStyle={[iconStyle, itemIconStyle]}
            textStyle={[textStyle, itemTextStyle]}
            {...otherProps}
          />
          {!unfoldAtTop && !unfolded && opened && items?.map((item) => renderItem(item, level + 1))}
        </View>
      </View>
    )
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {data.map((data) => renderItem(data))}
    </View>
  )
}

export default Menu
